import { LineChart as RechartsLineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Area } from 'recharts';
import { tokens } from '../../theme/tokens';

interface LineChartProps {
  data: any[];
  xKey: string;
  lines: { key: string; color?: string; dashed?: boolean; name?: string }[];
  height?: number;
  showGrid?: boolean;
  showArea?: boolean;
  formatY?: (value: number) => string;
  formatX?: (value: string) => string;
}

export function LineChartComponent({
  data,
  xKey,
  lines,
  height = 280,
  showGrid = true,
  showArea = false,
  formatY,
  formatX,
}: LineChartProps) {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <RechartsLineChart data={data} margin={{ top: 5, right: 20, left: 0, bottom: 5 }}>
        {showGrid && (
          <CartesianGrid strokeDasharray="3 3" stroke={tokens.divider} strokeOpacity={0.5} />
        )}
        <XAxis
          dataKey={xKey}
          tick={{ fontSize: 11, fill: tokens.t3 }}
          tickLine={false}
          axisLine={{ stroke: tokens.divider }}
          tickFormatter={formatX}
        />
        <YAxis
          tick={{ fontSize: 11, fill: tokens.t3 }}
          tickLine={false}
          axisLine={false}
          tickFormatter={formatY}
          width={50}
        />
        <Tooltip
          contentStyle={{
            background: tokens.surface,
            border: `1px solid ${tokens.cardBorder}`,
            borderRadius: 8,
            boxShadow: tokens.cardShadow,
            fontSize: 12,
            fontFamily: tokens.fontPrimary,
          }}
        />
        {lines.map((line, i) => (
          <Line
            key={line.key}
            type="monotone"
            dataKey={line.key}
            stroke={line.color || tokens.accent}
            strokeWidth={2.5}
            dot={false}
            activeDot={{ r: 4, fill: line.color || tokens.accent, stroke: tokens.surface, strokeWidth: 2 }}
            strokeDasharray={line.dashed ? '5 5' : undefined}
            name={line.name || line.key}
          />
        ))}
        {showArea && lines[0] && (
          <defs>
            <linearGradient id="areaGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor={lines[0].color || tokens.accent} stopOpacity={0.15} />
              <stop offset="95%" stopColor={lines[0].color || tokens.accent} stopOpacity={0.01} />
            </linearGradient>
          </defs>
        )}
      </RechartsLineChart>
    </ResponsiveContainer>
  );
}
